import React, { useState, useEffect, useReducer } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTheme } from '@material-ui/core';
import { createData, getOptionsToGraph } from './createDataForGraph';
import { updateStates } from './getDatas';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const STATE_INITIAL_VALUES = {
  daysDataOpen: [],
  daysDataSolved: [],
  daysLabel: [],

  weeksDataOpen: [],
  weeksDataSolved: [],
  weeksLabel: [],

  monthsDataOpen: [],
  monthsDataSolved: [],
  monthsLabel: [],
};

const reducer = (prevState, action) => {
  switch (action.type) {
    case 'day':
      return {
        ...prevState,
        daysDataOpen: action.dataOpen,
        daysDataSolved: action.dataSolved,
        daysLabel: action.label,
      };
    case 'week':
      return {
        ...prevState,
        weeksDataOpen: action.dataOpen,
        weeksDataSolved: action.dataSolved,
        weeksLabel: action.label,
      };
    case 'month':
      return {
        ...prevState,
        monthsDataOpen: action.dataOpen,
        monthsDataSolved: action.dataSolved,
        monthsLabel: action.label,
      };
    default:
      console.log("Erro")
  }
}

const initialData = createData([], [], []);

const GraphQuantOccurrence = ({ occurrences, optionToShowGraph, startDate, endDate }) => {
  const theme = useTheme();
  const [state, dispatch] = useReducer(reducer, STATE_INITIAL_VALUES);
  const [data, setData] = useState(initialData);

  useEffect(() => {
    updateStates({
      dispatch,
      occurrences,
      startDate,
      endDate
    });
  }, [occurrences]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    updateGraph();
  }, [optionToShowGraph, state]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateGraph = () => {
    const [dataOpen, dataSolved, label] =
      optionToShowGraph === 'day' ? [state.daysDataOpen, state.daysDataSolved, state.daysLabel] :
        optionToShowGraph === 'week' ? [state.weeksDataOpen, state.weeksDataSolved, state.weeksLabel] :
          [state.monthsDataOpen, state.monthsDataSolved, state.monthsLabel];

    let newDataOpenToShow = [];
    let newDataSolvedToShow = [];
    let newLabelToShow = [];

    dataOpen.forEach((data) => {
      newDataOpenToShow.push(data)
    });

    dataSolved.forEach((data) => {
      newDataSolvedToShow.push(data)
    });

    label.forEach((data) => {
      newLabelToShow.push(data)
    });

    setData(createData(newDataOpenToShow, newDataSolvedToShow, newLabelToShow));
  }

  const options = getOptionsToGraph(theme);

  return <Bar options={options} data={data} height={10} />;
}

export default GraphQuantOccurrence;